/*
 * Gavetil videohilsen – felles kode for produktside og handlekurv
 * Legges i temaet under Assets som: gt-videohilsen.js
 *
 * Lagrer videoens ID på ordren som attributtet "Videohilsen-ID"
 * (samme sted som "Mottaker-Navn"). Order Printer leser det derfra.
 */
(function () {
  if (window.GTVideo) return;

  var WORKER = 'https://gavetil-hilsen.weathered-brook-12d8.workers.dev';
  var ATTR = 'Videohilsen-ID';
  var MAX_SECONDS = 60;
  var MAX_BYTES = 195 * 1024 * 1024; // Cloudflare tar maks 200 MB per enkel opplasting

  var state = { mode: '', id: '', busy: false }; // mode: '' (ikke valgt) | 'text' | 'video'
  var listeners = [];
  var localPreviewUrl = '';
  // Nettleseren gir ikke alltid advarsel på mobil, men vi forsøker når opplasting pågår.
  window.addEventListener('beforeunload', function (event) {
    if (!state.busy) return;
    event.preventDefault();
    event.returnValue = '';
  });

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function emit() {
    var snapshot = { mode: state.mode, id: state.id, busy: state.busy };
    listeners.forEach(function (fn) {
      try { fn(snapshot); } catch (e) { console.log(e); }
    });
  }

  function onChange(fn) {
    listeners.push(fn);
    fn({ mode: state.mode, id: state.id, busy: state.busy });
  }

  function cartUpdate(body) {
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('cart_update_failed_' + r.status);
      return r.json();
    });
  }

  // Leser Videohilsen-ID fra et cart-objekt (fra /cart.js)
  function syncFromCart(cart) {
    var id = (cart && cart.attributes && cart.attributes[ATTR]) || '';
    var note = ((cart && cart.note) || '').trim();
    var changed = false;
    if (id !== state.id) { state.id = id; changed = true; }
    if (!state.mode) {
      if (id) { state.mode = 'video'; changed = true; }
      else if (note) { state.mode = 'text'; changed = true; }
    }
    if (changed) emit();
  }

  function loadFromCart() {
    return fetch(root() + 'cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { syncFromCart(cart); return cart; })
      .catch(function (e) { console.log(e); });
  }

  function setMode(mode) {
    if (state.busy || state.mode === mode) return;
    state.mode = mode;
    emit();
  }

  function setVideo(id) {
    // Ikke bekreft i grensesnittet før Shopify faktisk har lagret ID-en.
    var attrs = {};
    attrs[ATTR] = id;
    return cartUpdate({ note: '', attributes: attrs }).then(function () {
      try { sessionStorage.setItem('gt_cart_note', ''); } catch (e) {}
      state.id = id;
      state.mode = 'video';
      emit();
      return id;
    });
  }

  function removeVideo() {
    state.id = '';
    if (localPreviewUrl) { URL.revokeObjectURL(localPreviewUrl); localPreviewUrl = ''; }
    emit();
    var attrs = {};
    attrs[ATTR] = '';
    return cartUpdate({ attributes: attrs });
  }

  // Kalles når kunden lagrer en skrevet hilsen: fjerner eventuell video
  function clearVideoLocally() {
    if (!state.id) return;
    state.id = '';
    if (localPreviewUrl) { URL.revokeObjectURL(localPreviewUrl); localPreviewUrl = ''; }
    emit();
  }

  function getDuration(file) {
    return new Promise(function (resolve) {
      try {
        var v = document.createElement('video');
        v.preload = 'metadata';
        v.muted = true;
        var url = URL.createObjectURL(file);
        var done = function (val) { URL.revokeObjectURL(url); resolve(val); };
        v.onloadedmetadata = function () { done(v.duration); };
        v.onerror = function () { done(NaN); };
        setTimeout(function () { done(NaN); }, 5000);
        v.src = url;
      } catch (e) { resolve(NaN); }
    });
  }

  function uploadFile(file, onProgress) {
    // Prosenten gjelder overføring av filen, ikke Cloudflares videobehandling.
    return fetch(WORKER + '/upload', { method: 'POST', cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) throw new Error('init_failed_' + r.status);
        return r.json();
      })
      .then(function (init) {
        if (!init || !init.uploadURL || !init.id) throw new Error('bad_upload_response');
        return new Promise(function (resolve, reject) {
          var xhr = new XMLHttpRequest();
          var settled = false;
          var lastActivity = Date.now();
          var watchdog;
          function finish(error, id) {
            if (settled) return;
            settled = true;
            clearInterval(watchdog);
            if (error) reject(error);
            else resolve(id);
          }
          xhr.open('POST', init.uploadURL);
          xhr.timeout = 10 * 60 * 1000;
          xhr.upload.onprogress = function (e) {
            lastActivity = Date.now();
            if (e.lengthComputable && onProgress) onProgress(e.loaded / e.total);
          };
          xhr.onload = function () {
            // Først en vellykket HTTP-respons bekrefter at opplastingen er mottatt.
            if (xhr.status >= 200 && xhr.status < 300) finish(null, init.id);
            else finish(new Error('upload_failed_' + xhr.status));
          };
          xhr.onerror = function () { finish(new Error('network')); };
          xhr.onabort = function () { finish(new Error('upload_aborted')); };
          xhr.ontimeout = function () { finish(new Error('upload_timeout')); };
          watchdog = setInterval(function () {
            // Ved 2 minutter uten fremdrift/HTTP-svar: stopp, vis feil og la kunden forsøke igjen.
            if (!settled && Date.now() - lastActivity > 120000) xhr.abort();
          }, 5000);
          var fd = new FormData();
          fd.append('file', file);
          try { xhr.send(fd); } catch (e) { finish(e); }
        });
      });
  }

  /* ---------- Utseende ---------- */

  function injectStyles() {
    if (document.getElementById('gtv-styles')) return;
    var css = '' +
      '.gtv-choice-title{margin:0 40px 14px 0!important;font-family:"Bodoni Moda",serif!important;font-size:18px!important;font-weight:400!important;letter-spacing:0.02em!important;line-height:1.3!important;color:#604D57!important;}' +
      '.gtv-choice-grid{display:grid!important;grid-template-columns:1fr 1fr!important;gap:10px!important;}' +
      '.gtv-choice-card{all:unset!important;box-sizing:border-box!important;display:flex!important;flex-direction:column!important;align-items:flex-start!important;gap:8px!important;padding:18px 16px 16px!important;border:0.5px solid rgba(96,77,87,0.25)!important;border-radius:4px!important;background:rgba(250,249,241,0.6)!important;cursor:pointer!important;text-align:left!important;transition:background .2s ease,border-color .2s ease!important;}' +
      '.gtv-choice-card:hover{background:rgba(250,249,241,0.95)!important;border-color:rgba(96,77,87,0.5)!important;}' +
      '.gtv-choice-card:focus-visible{outline:2px solid #604D57!important;outline-offset:2px!important;}' +
      '.gtv-choice-text{display:flex!important;flex-direction:column!important;gap:4px!important;}' +
      '.gtv-choice-icon{display:block;width:26px;height:26px;color:#604D57;}' +
      '.gtv-choice-card strong{font-family:"Figtree",sans-serif!important;font-size:13px!important;font-weight:500!important;letter-spacing:0.02em!important;color:#4f4048!important;}' +
      '.gtv-choice-card small{font-family:"Figtree",sans-serif!important;font-size:11px!important;font-weight:300!important;line-height:1.45!important;color:#786D70!important;}' +
      '.gtv-switch{display:flex!important;align-items:baseline!important;flex-wrap:wrap!important;gap:4px 12px!important;margin:0 40px 14px 0!important;padding-bottom:12px!important;border-bottom:0.5px solid rgba(96,77,87,0.18)!important;font-family:"Figtree",sans-serif!important;}' +
      '.gtv-switch-label{font-size:10px!important;font-weight:500!important;letter-spacing:0.14em!important;text-transform:uppercase!important;color:#4f4048!important;}' +
      '.gtv-switch-btn{all:unset!important;cursor:pointer!important;font-family:"Figtree",sans-serif!important;font-size:11px!important;color:#786D70!important;text-decoration:underline!important;text-underline-offset:3px!important;text-decoration-thickness:0.5px!important;}' +
      '.gtv-switch-btn:hover{color:#4f4048!important;}' +
      '@media (max-width:420px){.gtv-choice-grid{grid-template-columns:1fr!important;}.gtv-choice-card{flex-direction:row!important;align-items:center!important;gap:14px!important;}}' +
      '.gtv-panel{font-family:"Figtree",sans-serif;color:#4f4048;}' +
      '.gtv-panel .gtv-record,.gtv-panel label.gtv-record{margin:0!important;font-size:inherit!important;letter-spacing:0!important;text-transform:none!important;display:flex!important;align-items:center!important;gap:14px!important;width:100%!important;box-sizing:border-box!important;padding:18px 18px!important;border:0.5px dashed rgba(96,77,87,0.35)!important;border-radius:4px!important;background:rgba(250,249,241,0.55)!important;cursor:pointer!important;transition:background .2s ease,border-color .2s ease!important;}' +
      '.gtv-panel .gtv-record:hover{background:rgba(250,249,241,0.9)!important;border-color:rgba(96,77,87,0.55)!important;}' +
      '.gtv-dot{flex:0 0 auto;width:30px;height:30px;border-radius:50%;border:1px solid rgba(96,77,87,0.4);display:flex;align-items:center;justify-content:center;}' +
      '.gtv-dot::after{content:"";width:12px;height:12px;border-radius:50%;background:#FFA76E;}' +
      '.gtv-record-text{display:flex;flex-direction:column;gap:3px;text-align:left;}' +
      '.gtv-record-text strong{font-weight:500;font-size:13px;letter-spacing:0.02em;}' +
      '.gtv-record-text small{font-weight:300;font-size:11px;color:#786D70;}' +
      '.gtv-panel .gtv-pick,.gtv-panel label.gtv-pick{all:unset!important;cursor:pointer!important;display:inline-block!important;margin-top:10px!important;font-family:"Figtree",sans-serif!important;font-size:11px!important;font-weight:400!important;letter-spacing:0!important;text-transform:none!important;line-height:1.4!important;color:#786D70!important;text-decoration:underline!important;text-underline-offset:3px!important;text-decoration-thickness:0.5px!important;}' +
      '.gtv-panel .gtv-pick:hover{color:#4f4048!important;}' +
      '.gtv-progress-bar{height:2px;background:rgba(96,77,87,0.12);border-radius:2px;overflow:hidden;margin:6px 0 8px;}' +
      '.gtv-progress-bar span{display:block;height:100%;width:0;background:#604D57;transition:width .2s ease;}' +
      '.gtv-progress small,.gtv-note{font-size:11px;font-weight:300;color:#786D70;}' +
      '.gtv-done-card{display:flex;align-items:center;gap:16px;padding:12px;border:0.5px solid rgba(96,77,87,0.22);border-radius:6px;background:rgba(250,249,241,0.6);}' +
      '.gtv-panel .gtv-tile{all:unset!important;position:relative!important;flex:0 0 66px!important;width:66px!important;height:88px!important;border-radius:4px!important;overflow:hidden!important;background:#3C3036!important;cursor:pointer!important;box-shadow:0 1px 2px rgba(60,48,55,0.15)!important;}' +
      '.gtv-panel .gtv-tile:focus-visible{outline:2px solid #604D57!important;outline-offset:2px!important;}' +
      '.gtv-preview{position:absolute;inset:0;display:block;}' +
      '.gtv-tile-media{display:block;width:100%;height:100%;object-fit:cover;pointer-events:none;}' +
      '.gtv-tile-wait{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;text-align:center;padding:4px;font-size:9px;line-height:1.3;color:#FAF9F1;opacity:0.8;}' +
      '.gtv-tile-play{position:absolute;left:50%;top:50%;width:28px;height:28px;margin:-14px 0 0 -14px;border-radius:50%;background:rgba(250,249,241,0.92);display:flex;align-items:center;justify-content:center;box-shadow:0 2px 6px rgba(43,35,40,0.25);transition:transform .2s ease;}' +
      '.gtv-tile:hover .gtv-tile-play{transform:scale(1.08);}' +
      '.gtv-tile-play svg{width:11px;height:11px;margin-left:2px;}' +
      '.gtv-tile-dur{position:absolute;right:4px;bottom:4px;font-size:9px;font-weight:500;letter-spacing:0.04em;color:#FAF9F1;text-shadow:0 1px 2px rgba(0,0,0,0.5);}' +
      '.gtv-done-info{display:flex;flex-direction:column;align-items:flex-start;gap:4px;min-width:0;text-align:left;}' +
      '.gtv-ok{display:inline-flex;align-items:center;gap:6px;font-size:13px;font-weight:500;letter-spacing:0.01em;color:#4f4048;}' +
      '.gtv-ok svg{width:14px;height:14px;color:#604D57;}' +
      '.gtv-done-sub{font-size:11px;font-weight:300;line-height:1.4;color:#786D70;}' +
      '.gtv-done-actions{display:flex;align-items:center;gap:8px;margin-top:6px;}' +
      '.gtv-sep{font-size:11px;color:#A99FA2;}' +
      '.gtv-panel .gtv-link,.gtv-panel label.gtv-link{all:unset!important;display:inline!important;cursor:pointer!important;font-family:"Figtree",sans-serif!important;font-size:11px!important;font-weight:400!important;letter-spacing:0!important;text-transform:none!important;line-height:1.4!important;color:#786D70!important;text-decoration:underline!important;text-underline-offset:3px!important;text-decoration-thickness:0.5px!important;}' +
      '.gtv-panel .gtv-link:hover{color:#4f4048!important;}' +
      '.gtv-error{margin:10px 0 0;font-size:11px;line-height:1.4;color:#9C4A3C;}' +
      '.gtv-hidden{display:none!important;}';
    var s = document.createElement('style');
    s.id = 'gtv-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  var ICON_PEN = '<svg class="gtv-choice-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15.75 4.75L19.25 8.25M5.5 15L16.65 3.85C17.3 3.2 18.35 3.2 19 3.85L20.15 5C20.8 5.65 20.8 6.7 20.15 7.35L9 18.5L4.5 19.5L5.5 15Z" stroke="currentColor" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.5 15L9 18.5M12.5 20.5H20" stroke="currentColor" stroke-width="0.8" stroke-linecap="round"/></svg>';
  var ICON_VIDEO = '<svg class="gtv-choice-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="2.75" y="6.25" width="13" height="11.5" rx="1.5" stroke="currentColor" stroke-width="0.9"/><path d="M15.75 10.5L21.25 7.5V16.5L15.75 13.5" stroke="currentColor" stroke-width="0.9" stroke-linejoin="round"/><circle cx="7" cy="10" r="1.1" fill="#FFA76E"/></svg>';

  // Første steg: kunden velger skriftlig hilsen eller videohilsen.
  // Etter valget vises en liten linje med mulighet for å bytte.
  function mountChoice(el) {
    if (!el) return;
    injectStyles();
    el.innerHTML =
      '<div class="gtv-choice">' +
        '<p class="gtv-choice-title">Hvordan vil du hilse?</p>' +
        '<div class="gtv-choice-grid">' +
          '<button type="button" class="gtv-choice-card" data-mode="text">' + ICON_PEN +
            '<span class="gtv-choice-text"><strong>Skriv en hilsen</strong><small>Hilsenen trykkes på kortet som følger gaven.</small></span>' +
          '</button>' +
          '<button type="button" class="gtv-choice-card" data-mode="video">' + ICON_VIDEO +
            '<span class="gtv-choice-text"><strong>Spill inn en videohilsen</strong><small>Mottakeren skanner QR-koden på kortet og ser videoen.</small></span>' +
          '</button>' +
        '</div>' +
      '</div>' +
      '<div class="gtv-switch">' +
        '<span class="gtv-switch-label"></span>' +
        '<button type="button" class="gtv-switch-btn"></button>' +
      '</div>';

    var choice = el.querySelector('.gtv-choice');
    var sw = el.querySelector('.gtv-switch');
    var swLabel = el.querySelector('.gtv-switch-label');
    var swBtn = el.querySelector('.gtv-switch-btn');

    Array.prototype.forEach.call(el.querySelectorAll('.gtv-choice-card'), function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        setMode(b.getAttribute('data-mode'));
      });
    });
    swBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      setMode(state.mode === 'video' ? 'text' : 'video');
    });

    onChange(function (s) {
      var chosen = Boolean(s.mode);
      choice.classList.toggle('gtv-hidden', chosen);
      sw.classList.toggle('gtv-hidden', !chosen);
      swLabel.textContent = s.mode === 'video' ? 'Videohilsen' : 'Skriftlig hilsen';
      swBtn.textContent = s.mode === 'video' ? 'Bytt til skriftlig hilsen' : 'Bytt til videohilsen';
    });
  }

  function fmtDur(sec) {
    if (!sec || !isFinite(sec)) return '';
    var s = Math.max(1, Math.round(sec));
    return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
  }

  function mountPanel(el) {
    if (!el) return;
    injectStyles();
    el.innerHTML =
      '<div class="gtv-panel">' +
        '<div class="gtv-empty">' +
          '<label class="gtv-record">' +
            '<input type="file" accept="video/*" capture="user" class="gtv-input-camera" hidden>' +
            '<span class="gtv-dot" aria-hidden="true"></span>' +
            '<span class="gtv-record-text"><strong>Spill inn videohilsen</strong><small>Maks ' + MAX_SECONDS + ' sekunder · enklest på mobil</small></span>' +
          '</label>' +
          '<label class="gtv-pick">eller velg en video du har<input type="file" accept="video/*" class="gtv-input-file" hidden></label>' +
        '</div>' +
        '<div class="gtv-progress gtv-hidden">' +
          '<div class="gtv-progress-bar"><span></span></div>' +
          '<small class="gtv-progress-text">Laster opp …</small>' +
        '</div>' +
        '<div class="gtv-done gtv-hidden">' +
          '<div class="gtv-done-card">' +
            '<button type="button" class="gtv-tile" aria-label="Se videoen">' +
              '<span class="gtv-preview"></span>' +
              '<span class="gtv-tile-play" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M7 4.5L19 12L7 19.5Z" fill="#604D57"/></svg></span>' +
              '<span class="gtv-tile-dur"></span>' +
            '</button>' +
            '<div class="gtv-done-info">' +
              '<span class="gtv-ok"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8.5L6.5 12L13 4.5" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>Videohilsen lagt ved</span>' +
              '<small class="gtv-done-sub">Mottakeren skanner QR-koden på kortet for å se den.</small>' +
              '<div class="gtv-done-actions">' +
                '<label class="gtv-link">Spill inn på nytt<input type="file" accept="video/*" capture="user" class="gtv-input-redo" hidden></label>' +
                '<span class="gtv-sep" aria-hidden="true">·</span>' +
                '<button type="button" class="gtv-link gtv-remove">Fjern</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<p class="gtv-error gtv-hidden" role="alert"></p>' +
      '</div>';

    var empty = el.querySelector('.gtv-empty');
    var progress = el.querySelector('.gtv-progress');
    var bar = el.querySelector('.gtv-progress-bar span');
    var progressText = el.querySelector('.gtv-progress-text');
    var done = el.querySelector('.gtv-done');
    var preview = el.querySelector('.gtv-preview');
    var tile = el.querySelector('.gtv-tile');
    var durEl = el.querySelector('.gtv-tile-dur');
    var errorEl = el.querySelector('.gtv-error');
    var shownId = null;

    function show(which) {
      empty.classList.toggle('gtv-hidden', which !== 'empty');
      progress.classList.toggle('gtv-hidden', which !== 'progress');
      done.classList.toggle('gtv-hidden', which !== 'done');
    }

    function setError(msg) {
      errorEl.textContent = msg || '';
      errorEl.classList.toggle('gtv-hidden', !msg);
    }

    function renderPreview(id) {
      if (shownId === id && preview.firstChild) return;
      shownId = id;
      preview.innerHTML = '';
      durEl.textContent = '';
      if (localPreviewUrl) {
        var v = document.createElement('video');
        v.className = 'gtv-tile-media';
        v.src = localPreviewUrl + '#t=0.1';
        v.muted = true;
        v.preload = 'metadata';
        v.playsInline = true;
        v.setAttribute('playsinline', '');
        v.addEventListener('loadedmetadata', function () { durEl.textContent = fmtDur(v.duration); });
        preview.appendChild(v);
        return;
      }
      // Ingen lokal fil (f.eks. etter ny sideinnlasting): vis miniatyrbilde fra Cloudflare
      fetch(WORKER + '/video/' + id)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (info) {
          if (!info || shownId !== id) return;
          durEl.textContent = fmtDur(info.duration);
          if (info.thumbnail) {
            var img = document.createElement('img');
            img.className = 'gtv-tile-media';
            img.alt = 'Videohilsen';
            img.src = info.thumbnail;
            preview.appendChild(img);
          } else {
            preview.innerHTML = '<span class="gtv-tile-wait">Gjøres klar</span>';
          }
        })
        .catch(function () {});
    }

    function handleFile(file) {
      if (state.busy) return;
      setError('');
      if (!file) return;
      if (file.size > MAX_BYTES) {
        setError('Videoen er for stor. Prøv et kortere opptak (maks ' + MAX_SECONDS + ' sekunder).');
        return;
      }
      getDuration(file).then(function (secs) {
        if (secs && isFinite(secs) && secs > MAX_SECONDS + 1) {
          setError('Videoen er ' + Math.round(secs) + ' sekunder. Maks lengde er ' + MAX_SECONDS + ' sekunder.');
          return;
        }
        state.busy = true;
        emit();
        show('progress');
        bar.style.width = '0%';
        progressText.textContent = 'Laster opp … 0 %. Ikke lukk eller forlat siden før du får bekreftelse.';
        uploadFile(file, function (p) {
          var pct = Math.round(p * 100);
          bar.style.width = pct + '%';
          progressText.textContent = pct < 100 ? 'Laster opp … ' + pct + ' %. Ikke lukk siden.' : '100 % sendt. Snart klar. Ikke lukk siden.';
        })
          .then(function (id) {
            progressText.textContent = 'Videoen er mottatt. Lagrer videohilsenen på bestillingen …';
            return setVideo(id).then(function () {
              if (localPreviewUrl) URL.revokeObjectURL(localPreviewUrl);
              localPreviewUrl = URL.createObjectURL(file);
              shownId = null;
              state.busy = false;
              emit();
            });
          })
          .catch(function (e) {
            console.log('Videohilsen feilet', e);
            state.busy = false;
            emit();
            show(state.id ? 'done' : 'empty');
            setError('Videohilsenen ble ikke fullført eller lagret på bestillingen. Ikke gå videre før du har prøvd igjen og fått bekreftelse.');
          });
      });
    }

    ['.gtv-input-camera', '.gtv-input-file', '.gtv-input-redo'].forEach(function (sel) {
      var input = el.querySelector(sel);
      if (!input) return;
      input.addEventListener('change', function () {
        var f = input.files && input.files[0];
        input.value = '';
        handleFile(f);
      });
    });

    tile.addEventListener('click', function (e) {
      e.preventDefault();
      var v = preview.querySelector('video');
      if (!v) {
        // Ingen lokal fil: vis hilsenen slik mottakeren ser den
        if (state.id) window.open('https://gavetil.no/pages/videohilsen?id=' + state.id, '_blank');
        return;
      }
      v.src = localPreviewUrl;
      v.muted = false;
      v.controls = true;
      var reset = function () {
        if (document.fullscreenElement || document.webkitFullscreenElement) return;
        v.pause(); v.controls = false; v.muted = true;
        v.removeAttribute('src'); v.src = localPreviewUrl + '#t=0.1';
        document.removeEventListener('fullscreenchange', reset);
        document.removeEventListener('webkitfullscreenchange', reset);
        v.removeEventListener('webkitendfullscreen', reset);
      };
      document.addEventListener('fullscreenchange', reset);
      document.addEventListener('webkitfullscreenchange', reset);
      v.addEventListener('webkitendfullscreen', reset);
      var p = v.play();
      if (v.requestFullscreen) v.requestFullscreen().catch(function () {});
      else if (v.webkitEnterFullscreen) v.webkitEnterFullscreen();
      else if (v.webkitRequestFullscreen) v.webkitRequestFullscreen();
      if (p && p.catch) p.catch(function () {});
    });

    el.querySelector('.gtv-remove').addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      setError('');
      removeVideo();
    });

    // Hindrer at klikk i panelet lukker modalen eller trigger andre klikk-lyttere
    el.addEventListener('click', function (e) { e.stopPropagation(); });

    onChange(function (s) {
      if (s.busy) { show('progress'); return; }
      if (s.id) { show('done'); renderPreview(s.id); }
      else { shownId = null; preview.innerHTML = ''; show('empty'); }
    });
  }

  /* ---------- Gaveesken med kortet (live forhåndsvisning) ---------- */

  var GIFT_IMG = 'https://cdn.shopify.com/s/files/1/0693/4069/2550/files/hele_gaveesken_1.webp?v=1791115995';

  // Tråden som går over kortet, målt i bildets egne piksler (bildet er 2000 × 1500).
  // En smal stripe av selve bildet legges over teksten, så tråden ligger oppå og teksten ser trykt ut.
  var STRING = { x: 320, y: 548, w: 17, h: 360 };

  // Plassholder før videoen finnes: ser ut som en QR-kode, men kan ikke skannes
  function qrPlaceholderSvg() {
    var c = '#3C3036', n = 21, seed = 7, cells = '';
    function rnd() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
    function inFinder(x, y) {
      return (x < 8 && y < 8) || (x > n - 9 && y < 8) || (x < 8 && y > n - 9);
    }
    for (var y = 0; y < n; y++) {
      for (var x = 0; x < n; x++) {
        if (inFinder(x, y)) continue;
        if (rnd() < 0.48) cells += 'M' + x + ' ' + y + 'h1v1h-1z';
      }
    }
    function finder(x, y) {
      return '<rect x="' + x + '" y="' + y + '" width="7" height="7" fill="' + c + '"/>' +
        '<rect x="' + (x + 1) + '" y="' + (y + 1) + '" width="5" height="5" fill="#fff"/>' +
        '<rect x="' + (x + 2) + '" y="' + (y + 2) + '" width="3" height="3" fill="' + c + '"/>';
    }
    return '<svg viewBox="0 0 ' + n + ' ' + n + '" xmlns="http://www.w3.org/2000/svg" shape-rendering="crispEdges" aria-hidden="true">' +
      '<rect width="' + n + '" height="' + n + '" fill="#fff"/>' +
      '<path d="' + cells + '" fill="' + c + '"/>' +
      finder(0, 0) + finder(n - 7, 0) + finder(0, n - 7) +
      '</svg>';
  }

  // Ekte QR-kode når videoen er lastet opp (samme lenke som på kortet i esken)
  function qrRealImg(id) {
    var url = 'https://gavetil.no/pages/videohilsen?id=' + id;
    return '<img alt="QR-kode til videohilsenen" src="https://api.qrserver.com/v1/create-qr-code/?size=300x300&margin=0&color=3C3036&bgcolor=ffffff&data=' +
      encodeURIComponent(url) + '" style="display:block;width:100%;height:100%;">';
  }

  function injectPreviewStyles() {
    if (document.getElementById('gtp-styles')) return;
    var css = '' +
      '.gtp-label{font-family:"Figtree",sans-serif!important;color:rgba(79,64,72,0.57)!important;font-size:8px!important;font-weight:500!important;letter-spacing:0.15em!important;text-transform:uppercase!important;line-height:1.2!important;margin:0 0 10px!important;}' +
      '.gtp-wrap{position:relative!important;width:100%!important;overflow:visible!important;background:transparent!important;}' +
      '.gtp-img{display:block!important;width:100%!important;height:auto!important;user-select:none!important;pointer-events:none!important;filter:drop-shadow(1px 2px 1px rgba(52,39,32,0.22)) drop-shadow(12px 10px 7px rgba(52,39,32,0.34))!important;}' +
      '.gtp-card{position:absolute!important;left:17%!important;top:39.1%!important;width:350px!important;height:220px!important;transform:rotate(37.5deg) scale(var(--gtp-scale,0))!important;transform-origin:top left!important;box-sizing:border-box!important;padding:4px 10px 0 22px!important;overflow:hidden!important;pointer-events:none!important;color:#42383E!important;z-index:3!important;text-align:left!important;}' +
      '.gtp-to{display:block!important;color:#B78676!important;font-family:"Figtree",sans-serif!important;font-size:var(--gtp-to-size,11px)!important;font-weight:500!important;line-height:1.2!important;letter-spacing:0.16em!important;text-transform:uppercase!important;margin:0 0 12px!important;white-space:normal!important;overflow-wrap:anywhere!important;mix-blend-mode:multiply!important;}' +
      '.gtp-to:not(:empty)::after{content:"";display:block;width:56px;border-top:1px solid #C8A69A;margin-top:8px;}' +
      '.gtp-to:empty{display:none!important;}' +
      '.gtp-msg{display:block!important;color:#3D3634!important;font-family:Arial,Helvetica,sans-serif!important;font-size:var(--gtp-msg-size,14px)!important;line-height:1.35!important;font-weight:400!important;margin:0!important;white-space:pre-wrap!important;overflow-wrap:anywhere!important;mix-blend-mode:multiply!important;}' +
      '.gtp-card.is-video .gtp-to{padding-left:4px!important;}' +
      '.gtp-video{display:flex!important;align-items:center!important;gap:14px!important;margin:4px 0 0 82px!important;}' +
      '.gtp-qr{flex:0 0 76px!important;width:76px!important;height:76px!important;display:block!important;}' +
      '.gtp-qr svg,.gtp-qr img{display:block;width:100%;height:100%;mix-blend-mode:multiply;opacity:0.92;}' +
      '.gtp-vtext{font-family:"Figtree",sans-serif!important;font-size:12px!important;line-height:1.4!important;color:#282522!important;max-width:160px!important;}' +
      '.gtp-vtext strong{display:block!important;font-weight:500!important;font-size:13px!important;margin-bottom:5px!important;}' +
      '.gtp-string{position:absolute!important;z-index:4!important;pointer-events:none!important;background-repeat:no-repeat!important;}' +
      '.gtp-hidden{display:none!important;}' +
      '.gtp-note{font-family:"Figtree",sans-serif!important;font-size:11px!important;font-weight:400!important;line-height:1.5!important;letter-spacing:0.01em!important;color:rgba(79,64,72,0.72)!important;max-width:78%!important;margin:8px auto 0!important;padding:0!important;text-align:center!important;text-wrap:balance;}';
    var s = document.createElement('style');
    s.id = 'gtp-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  // Viser gaveesken med kortet. getTo/getNote henter tekst fra feltene på siden.
  function mountGiftPreview(el, opts) {
    if (!el) return null;
    opts = opts || {};
    injectPreviewStyles();
    el.innerHTML =
      (opts.showLabel ? '<div class="gtp-label">Slik blir hilsenen levert</div>' : '') +
      '<div class="gtp-wrap">' +
        '<img class="gtp-img" src="' + GIFT_IMG + '" alt="Forhåndsvisning av gave med personlig hilsen" width="2000" height="1500" loading="eager">' +
        '<div class="gtp-card" aria-hidden="true">' +
          '<div class="gtp-to"></div>' +
          '<div class="gtp-msg"></div>' +
          '<div class="gtp-video gtp-hidden">' +
            '<span class="gtp-qr"></span>' +
            '<span class="gtp-vtext"><strong>Noen har en hilsen til deg</strong>Skann koden med kameraet på mobilen for å se den.</span>' +
          '</div>' +
        '</div>' +
        '<div class="gtp-string" aria-hidden="true"></div>' +
      '</div>' +
      '<p class="gtp-note">Esken kommer i en forsendelsespose. Ingen ser hilsenen før den er fremme.</p>';

    var wrap = el.querySelector('.gtp-wrap');
    var img = el.querySelector('.gtp-img');
    var card = el.querySelector('.gtp-card');
    var toEl = el.querySelector('.gtp-to');
    var msgEl = el.querySelector('.gtp-msg');
    var videoEl = el.querySelector('.gtp-video');
    var qrEl = el.querySelector('.gtp-qr');
    var stringEl = el.querySelector('.gtp-string');
    var qrFor = null;

    function placeString(s) {
      stringEl.style.left = (STRING.x * s) + 'px';
      stringEl.style.top = (STRING.y * s) + 'px';
      stringEl.style.width = (STRING.w * s) + 'px';
      stringEl.style.height = (STRING.h * s) + 'px';
      stringEl.style.backgroundImage = 'url("' + GIFT_IMG + '")';
      stringEl.style.backgroundSize = (2000 * s) + 'px ' + (1500 * s) + 'px';
      stringEl.style.backgroundPosition = (-STRING.x * s) + 'px ' + (-STRING.y * s) + 'px';
    }

    function update() {
      var to = ((opts.getTo && opts.getTo()) || '').trim();
      var note = ((opts.getNote && opts.getNote()) || '').trim();
      var showVideo = state.mode === 'video';
      toEl.textContent = to ? 'TIL ' + to.toUpperCase() : '';
      msgEl.textContent = showVideo ? '' : note;
      msgEl.classList.toggle('gtp-hidden', showVideo);
      videoEl.classList.toggle('gtp-hidden', !showVideo);
      card.classList.toggle('is-video', showVideo);
      var qrKey = state.id || '';
      if (qrFor !== qrKey) {
        qrFor = qrKey;
        qrEl.innerHTML = state.id ? qrRealImg(state.id) : qrPlaceholderSvg();
      }
      if (!wrap.clientWidth) return;
      var scale = wrap.clientWidth / 2000;
      placeString(scale);
      card.style.setProperty('--gtp-scale', scale);
      card.style.setProperty('--gtp-to-size', '11px');
      var size = 14;
      card.style.setProperty('--gtp-msg-size', size + 'px');
      while (!showVideo && card.scrollHeight > card.clientHeight && size > 1) {
        size -= 0.5;
        card.style.setProperty('--gtp-msg-size', size + 'px');
        card.style.setProperty('--gtp-to-size', Math.min(11, size) + 'px');
      }
    }

    img.addEventListener('load', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(wrap);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
    onChange(update);
    return { update: update };
  }

  window.GTVideo = {
    ATTR: ATTR,
    WORKER: WORKER,
    state: state,
    onChange: onChange,
    loadFromCart: loadFromCart,
    syncFromCart: syncFromCart,
    setMode: setMode,
    removeVideo: removeVideo,
    clearVideoLocally: clearVideoLocally,
    mountChoice: mountChoice,
    mountTabs: mountChoice,
    mountPanel: mountPanel,
    mountGiftPreview: mountGiftPreview,
    hasVideo: function () { return state.mode === 'video' && !!state.id; }
  };
})();